<template>
  <div class="shadow-sm relative flex rounded-xl p-0.5 w-modal-md gradient">
    <div class="w-full h-full grow shrink p-8 bg-white rounded-xl">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped>
  .gradient {
    background: linear-gradient(90deg, var(--color-blue-20) 0%, var(--color-blue-50) 100%);
  }
</style>
